import { gql } from '@apollo/client';

export const WAIVE_REPORTING_PERIODS = gql`
  mutation waiveReportingPeriods($input: WaiveReportingPeriodsInput!) {
    result: waiveReportingPeriods(input: $input) {
      updated
    }
  }
`;
